import { useEffect, useRef } from "react";

const Starfield = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let stars = [];
    let raf;
    let mx = 0;
    let my = 0;
    let t = 0;

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      const count = Math.min(180, Math.floor((canvas.width * canvas.height) / 9000));
      stars = Array.from({ length: count }, () => ({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        r: Math.random() * 1.3 + 0.3,
        depth: Math.random() * 0.8 + 0.2,
        phase: Math.random() * Math.PI * 2,
        speed: Math.random() * 0.06 + 0.02,
        gold: Math.random() < 0.18,
      }));
    };

    const onMouse = (e) => {
      mx = (e.clientX / window.innerWidth - 0.5) * 2;
      my = (e.clientY / window.innerHeight - 0.5) * 2;
    };

    const draw = () => {
      t += 0.016;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (const s of stars) {
        const twinkle = 0.35 + 0.65 * Math.abs(Math.sin(t * 0.8 + s.phase));
        const px = s.x + mx * 22 * s.depth;
        const py = s.y + my * 22 * s.depth + t * s.speed * 8;
        const yy = py % canvas.height;
        ctx.beginPath();
        ctx.arc(px, yy < 0 ? yy + canvas.height : yy, s.r, 0, Math.PI * 2);
        ctx.fillStyle = s.gold
          ? `rgba(184,150,42,${0.75 * twinkle * s.depth})`
          : `rgba(22,34,61,${0.4 * twinkle * s.depth})`;
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    };

    resize();
    draw();
    window.addEventListener("resize", resize);
    window.addEventListener("mousemove", onMouse);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", resize);
      window.removeEventListener("mousemove", onMouse);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 z-0 pointer-events-none"
      data-testid="starfield-canvas"
    />
  );
};

export default Starfield;
